module.exports = __webpack_public_path__ + "img/update-icon.607a2568.svg";